import { render, staticRenderFns } from "./CertificateFileUpload.vue?vue&type=template&id=66ee7b91&"
import script from "./CertificateFileUpload.vue?vue&type=script&lang=js&"
export * from "./CertificateFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./CertificateFileUpload.vue?vue&type=style&index=0&id=66ee7b91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports